import { injectable } from 'inversify-props'
import { PagamentoServiceAdapter } from '@/usecases/venda'
import { FormPagamento } from '@/models'
import { efetuarPagamentoTef, consultarPagamentoTef, cancelarPagamentoTef, buscarDetalhesDoPagamento, consultarUltimoPagamentoTefPelaVenda, findPagamentosDetalhadosByVendaId } from '@/api/pagamento'

@injectable()
export class PagamentoService implements PagamentoServiceAdapter {
	efetuarPagamentoTef = async (idPdv: string, pagamento: FormPagamento, identificadorDaVenda: string) => await efetuarPagamentoTef(idPdv, pagamento, identificadorDaVenda)
	consultarPagamentoTef = async (pdvId: string, detalhesDoPagamentoId: string) => await consultarPagamentoTef(pdvId, detalhesDoPagamentoId)
	cancelarPagamentoTef = async (pdvId: string, detalhesDoPagamentoId: string) => await cancelarPagamentoTef(pdvId, detalhesDoPagamentoId)
	buscarDetalhesDoPagamento = async (detalhesDoPagamentoId: string) => await buscarDetalhesDoPagamento(detalhesDoPagamentoId)
	consultarUltimoPagamentoTefPelaVenda = async (identificadorDaVenda: string) => await consultarUltimoPagamentoTefPelaVenda(identificadorDaVenda)
	findPagamentosDetalhadosByVendaId = async (vendaId: string) => await findPagamentosDetalhadosByVendaId(vendaId)
}
